module.exports = __webpack_public_path__ + "img/heading-01.ba3e1d6a.svg";